export const handleEventSearch = (event) => {
    try {
        const { action, label, value } = event;
        if (!action || !label) {
            throw new Error(`handling unknown event ${JSON.stringify(event)}`);
        }
        var dataLayerEvent = {
            event: "beon_gaevent",
            eventAction: action,
            eventLabel: label,
            eventValue: value,
            eventCategory: "beon-search"
        };
        (window.dataLayer || []).push(dataLayerEvent);

        return dataLayerEvent;
    } catch (e) {
        console.log(e);
        return;
    }
};

export const handleEventSearchTerm = ({ action, term, resultsCount}) => {
    const dataEvent = {
        action,
        label: term,
        value: resultsCount,
    }
    return handleEventSearch(dataEvent);
};

export const handleEventSearchProductClick = ({ term, productLabel }) => {
    const dataEvent = {
        action: 'hit',
        label: term,
        value: productLabel,
    }
    return handleEventSearch(dataEvent);
};

export const debounceAction = (fn, wait) => {
    let timer;
    return function(...args) {
        if(timer) clearTimeout(timer);
        timer = setTimeout(() => fn(...args), wait);
    }
}